import { Component, OnInit, NgZone, AfterViewInit, Output, Input, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { View, Feature, Map } from 'ol';
import { Coordinate,toStringHDMS } from 'ol/coordinate';
import { ScaleLine, defaults as DefaultControls } from 'ol/control';
import proj4 from 'proj4';
import VectorLayer from 'ol/layer/Vector';
import Projection from 'ol/proj/Projection';
import { register } from 'ol/proj/proj4';
import { get as GetProjection } from 'ol/proj'
import { Extent } from 'ol/extent';
import Overlay from 'ol/Overlay';
import ImageWMS from 'ol/source/ImageWMS';

//import TileLayer from 'ol/layer/Tile';
import * as olProj from 'ol/proj';
import { Group as LayerGroup, Image as ImageLayer, Tile as TileLayer } from 'ol/layer';
import OSM, { ATTRIBUTION } from 'ol/source/OSM';
import { URL_GEOSERVER } from '../global/config';
declare var $: any;

@Component({
  selector: 'app-mapa2',
  templateUrl: './mapa2.component.html',
  styleUrls: ['./mapa2.component.css']
})
export class Mapa2Component implements OnInit, AfterViewInit {

  @Input() ev: any;
  @Input() center: Coordinate;
  @Input() zoom: number;
  view: View;
  projection: Projection;
  extent: Extent = [176393.3238, 8502444.2163, 179199.5594, 8504629.6843];
  Map: Map;
  
  @Output() mapReady = new EventEmitter<Map>();

  viewTocMap: boolean = true;
  
  // CONFIG-GEOSERVER-PROVIDER:
  //urlGeoserver: string = 'http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms'; 
  urlGeoserverOld: string = 'http://localhost:8080/geoserver/gchc.catalogacion/wms'; 
  urlGeoserver: string = URL_GEOSERVER.UrlGeoserver;

  lotesWmsSource: ImageWMS = new ImageWMS({
    url: this.urlGeoserver,
    params: {'LAYERS': 'gchc.catalogacion:lotes', 'TILED': true},
    serverType: 'geoserver',
    //transition: 0,
  }); 

  infi: Object = {};

  //
  //---------------OVERLAYS------------------------------

  container = document.getElementById('popup');
  content = document.getElementById('popup-content');
  closer = document.getElementById('popup-closer');
  overlay: Overlay;

  constructor(private zone: NgZone, private cd: ChangeDetectorRef) { }



  ngAfterViewInit(): void {
    if (!this.Map) {
      this.zone.runOutsideAngular(() => this.initMap())
    }
    setTimeout(() => this.mapReady.emit(this.Map));
    //---------------------------------------
    //--------------------------------------

    $(document).ready(function () {
       /// alert('we call alert from JQuery');


      $('#layertree li > span')
        .click(function () {
          $(this).siblings('fieldset').toggle();
        })
        .siblings('fieldset')
        .hide();

      $('#infimo')
      .click(function() {
        alert('holammmmm');
      });

    });

  }
  ngOnInit(){
    this.infi={'hola':'hello'}
  }

  private initMap(): void {
    //proj4.defs("EPSG:32719", "+proj=utm +zone=19 +south +datum=WGS84 +units=m +no_defs");
    //register(proj4)
    //this.projection = GetProjection('EPSG:32719');
    //this.projection.setExtent(this.extent);
    this.view = new View({
      //center: olProj.transform(this.center, 'EPSG:4326', 'EPSG:32719'),
      center: olProj.transform(this.center, 'EPSG:4326', 'EPSG:3857'),
      zoom: this.zoom,
      //projection: this.projection,
    });
    this.overlay = new Overlay({
      element: document.getElementById('popup'),
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });

    this.Map = new Map({
      layers: [
        new TileLayer({
          source: new OSM({})
        }),
        new LayerGroup({
          layers: [
            new ImageLayer({
              extent: [-13884991, 2870341, -7455066, 6338219],
              source: new ImageWMS({
                url: 'https://ahocevar.com/geoserver/wms',
                params: { 'LAYERS': 'topp:states' },
                ratio: 1,
                serverType: 'geoserver',
              }),
            }),
            new ImageLayer({
              //title: 'Inmebles Relig. Bloques 1er Nivel',
              source: new ImageWMS({
                //url: 'http://172.16.7.144:8080/geoserver/ws_catalogacion_gchc/wms',
                //url: "http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms",
                url: this.urlGeoserver,
                params: { 'LAYERS': 'gchc.catalogacion:borde_gchc', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              }),
            }),
            new ImageLayer({
              //title: 'Sectores Temático',
              source: new ImageWMS({
                //url: 'http://172.16.7.144:8080/geoserver/ws_catalogacion_gchc/wms',
                //url: "http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms",
                url: this.urlGeoserver,
                params: {'LAYERS': 'gchc.catalogacion:sectores','STYLES': 'cat_sectores_colores_sld', 'TILED': true},
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              source: new ImageWMS({
                //url: 'http://172.16.7.144:8080/geoserver/ws_catalogacion_gchc/wms',
                //url: URL_GEOSERVER_V2,
                //url: "http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms",
                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: {'LAYERS': 'gchc.catalogacion:sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),
            new ImageLayer({
              //title: 'Sectores',
              source: new ImageWMS({
                //url: 'http://172.16.7.144:8080/geoserver/ws_catalogacion_gchc/wms',
                //url: URL_GEOSERVER_V2,
                //url: "http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms",
                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: {'LAYERS': 'gchc.catalogacion:lotes', 'TILED': true},
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            })
          ]
        })
        ,
      ],
      overlays: [this.overlay],
      target: 'map',
      view: this.view,
      controls: DefaultControls().extend([
        new ScaleLine({}),
      ]),
    });

    function bindInputs(layerid, layer) {
      var visibilityInput = $(layerid + ' input.visible');
      visibilityInput.on('change', function () {
        layer.setVisible(this.checked);
      });
      visibilityInput.prop('checked', layer.getVisible());

      var opacityInput = $(layerid + ' input.opacity');
      opacityInput.on('input', function () {
        layer.setOpacity(parseFloat(this.value));
      });
      opacityInput.val(String(layer.getOpacity()));
    };

    function setup(id, group) {
      group.getLayers().forEach(function (layer, i) {
        var layerid = id + i;
        bindInputs(layerid, layer);
        if (layer instanceof LayerGroup) {
          setup(layerid, layer);
        }
      });
    }
    setup('#layer', this.Map.getLayerGroup());
    
    //------------------------------------------------------------------------------------------------
    //feature info------------------------------------------------------------------------------------
    //------------------------------------------------------------------------------------------------
    
    this.Map.on('click', (evt) => {

      //console.log(this.view.getResolution());
      
      document.getElementById('info').innerHTML = '';
      var viewResolution = /** @type {number} */ 
            (this.view.getResolution());
      var url = this.lotesWmsSource.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        'EPSG:3857',
        //{'INFO_FORMAT': 'text/html'},
        {'INFO_FORMAT': 'application/json'},
      );
      /*
      if (url) {
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            document.getElementById('info').innerHTML = html;
          });
      }
      */
      if (url) {
        fetch(url)
          .then( (response) => {
            return response.text();
          //    console.log(response.text());
          
          })
          .then( (html) => {
            document.getElementById('info').innerHTML = html;
            //convirtiendo a objeto JSON
            var info_lote = JSON.parse(html);
            console.log(info_lote.features[0].properties)
  
            //-------------------
            var coordinate = evt.coordinate;
            var hdms = toStringHDMS(olProj.toLonLat(coordinate));
            var foto = info_lote.features[0].properties.codregistr;
  
            //document.getElementById('info').innerHTML = '';
            this.infi = info_lote.features[0].properties;
            
            //-------------------------------------------------------
            document.getElementById('popup-content').innerHTML = 
              '<p class=\'item-line-pop-up\'> <img width=200 src=\'http://172.16.7.144/registrofotografico/'+foto.substring(0,10)+'/arquitectonica/F21.jpg\'>' +
              '<p class=\'item-line-pop-up\'> Reg.Foto.: <b><a href=\'http://172.16.7.144/registrofotografico/'+foto.substring(0,10) +'\' target="_blank">'+ 'http://172.16.7.144/registrofotografico/'+foto.substring(0,10)+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Cod.Lote: <b><a >'+ info_lote.features[0].properties.cod_lote+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Cod.Ficha: <b><a href=\''+ info_lote.features[0].properties.cod_catalo +'\'>'+ info_lote.features[0].properties.cod_catalo+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Sector: <b><a href=\'http://172.16.7.144/catalogacion/sector/'+info_lote.features[0].properties.cod_sector+'\'>'+ info_lote.features[0].properties.cod_sector+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Barrio: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.barrio_1+'\'>'+ info_lote.features[0].properties.barrio_1+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Cat. Catalogación: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.catcatalog+'\'>'+ info_lote.features[0].properties.catcatalog+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Cat. Zonificación: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.catzonific+'\'>'+ info_lote.features[0].properties.catzonific+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Dirección: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.dirección+'\'>'+ info_lote.features[0].properties.dirección+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Filiación Cult.: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.fil_cultur+'\'>'+ info_lote.features[0].properties.fil_cultur+'</a></b></p>' +
              '<p class=\'item-line-pop-up\'> Nro. Res. Patrim.: <b><a href=\'http://172.16.7.144/catalogacion/barrio/'+info_lote.features[0].properties.nreslpatri+'\'>'+ info_lote.features[0].properties.nreslpatri+'</a></b></p>' +
              '<code class=\'item-line-pop-up text-grey\'> coord. [' + hdms + ']</code>' ;
              //----------------

              //----------------
              console.log('coordinate: '+coordinate);
              this.overlay.setPosition(coordinate);
            
            // info_box_html.innerHTML = 'result: '+info_lote.features[0].properties.direcci_1;
  
            // ver_info(info_lote.features[0].properties)
  
            //----------------
            var folder = 'http://172.16.7.144/registrofotografico/'+foto.substring(0,10);
            $.ajax({
              url: folder,
              success: function(data) {
                $(data).find("a").attr("href", function(i, val) {
                  $("body").append("<img src='" + folder + '/' + val + "'>");
                });
              }
            });
            //----------------

           
            
          });
         
          
      }
      
    });

   
    

  }
  /*
  getCoord(ev:any){
    var coordinate = this.Map.getEventCoordinate(ev);

    console.log(coordinate);
 }
 */
  toggleTocMap(){
    if(this.viewTocMap){
      this.viewTocMap = false
    } else{
      this.viewTocMap = true
    }
  }


}
